import {
  GET_BUSINESS_LOCATION,
  LOADING,
  PAGINATION_LOADING,
  PRODUCT_AVAILABILITY,
  GET_MENUS,
  OUTLATES,
  PRODUCT,
  CASHREGISTER,
  PRODUCT_VARIATION,
  GET_MENUS_BY_ID,
  ADD_TO_CART,
  ORDER,
  DELETE_CART,
  ORDERS,
  ORDER_HISTORY,
  RE_ORDERS,
  REGISTER,
  GET_ERRORS,
  CLEAR_STATE,
  SET_REGISTERED_USER,
  SET_CURRENT_USER,
  SET_LOGIN_ERROR,
  PAYMENT,
  CATEGORY,
  TRACK_ORDER,
  TAX,
  GET_CUSTOMER_PROFILE,
  UPDATE_CUSTOMER_PROFILE,
  PLACE_ORDER_PRODUCT,
  SET_STRIPE_LALAMOVE_KEY,
  GET_PREPARATION_TIME,
  GET_STATUS_DELIVERY_STORE,
  CHECK_OUT_PRODUCT,
  GET_CURRENT_OUTLET,
  SET_TOTAL_ORDERS,
  TOTAL_ORDERS_LOADER_START,
  PRODUCT_COMBO,
  OWN_DELIVERY_QUOTE,
  OWN_DELIVERY_QUOTE_SUCCESS,
  OWN_DELIVERY_QUOTE_FAIL
} from "../actions/types";
const initialState = {
  cashregister: null,
  business_location: null,
  get_menus: null,
  child_products: null,
  product_hierarchy: null,
  product: null,
  product_id: null,
  variation: null,
  loading: false,
  paginationLoading: false,
  outlates: null,
  add_to_cart: null,
  get_menus_by_id: null,
  order: null,
  orders: null,
  order_history: null,
  reorders: null,
  signup: null,
  errors: null,
  payment: null,
  tax: null,
  category: null,
  track_order: null,
  place_order: null,
  stripeLalaMoveKeys: [],
  est_prep_time: null,
  outlet_status: false,
  getCheckOutProduct: [],
    api_availability: [],
  own_delivery_quote: null,
  own_delivery_quote_loading: false,
  own_delivery_quote_error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        loading: true,
        paginationLoading: false,
      };

    case PAGINATION_LOADING:
      return {
        ...state,
        paginationLoading: true,
        loading: false,
      };

    case CATEGORY:
      return {
        ...state,
        category: action.payload,
        errors: null,
        loading: false,
      };

    case TAX:
      return {
        ...state,
        tax: action.payload,
        errors: null,
        loading: false,
      };

    case PAYMENT:
      return {
        ...state,
        payment: action.payload,
        errors: null,
        loading: false,
      };

    case CLEAR_STATE:
      return {
        ...state,
        signup: null,
        errors: null,
        loading: false,
      };

    case GET_BUSINESS_LOCATION:
      return {
        ...state,
        business_location: action.payload
      }
    //DEL-1 :: OWN DELIVERY QUOTE (/own_delivery_quote)
    case OWN_DELIVERY_QUOTE:
      return {
        ...state,
        own_delivery_quote_loading: true,
        own_delivery_quote_error: null
      }
    case OWN_DELIVERY_QUOTE_SUCCESS:
      return {
        ...state,
        own_delivery_quote: action.payload,
        own_delivery_quote_loading: false,
        own_delivery_quote_error: null
      }
    case OWN_DELIVERY_QUOTE_FAIL:
      return {
        ...state,
        own_delivery_quote: null,
        own_delivery_quote_loading: false,
        own_delivery_quote_error: action.payload || null
      }
    case GET_STATUS_DELIVERY_STORE:
      return {
        ...state,
        outlet_status: action.payload,
        loading: false,
      }
    case GET_PREPARATION_TIME:
      return {
        ...state,
        est_prep_time: action.payload
      }

    case PRODUCT:
      return {
        ...state,
        product: action.payload,
        errors: null,
        loading: false,
        paginationLoading: false,
      };
    case PRODUCT_AVAILABILITY:
    return {
      ...state,
      api_availability: action.payload,
    };
    case CASHREGISTER:
      return {
        ...state,
        cashregister: action.payload,
        errors: null,
        loading: false,
      };
    case PRODUCT_VARIATION:
      return {
        ...state,
        variation: action.payload,
        errors: null,
        loading: false,
      };

    case GET_MENUS:
      return {
        ...state,
        get_menus: action.payload,
        loading: false,
      };

    case GET_MENUS_BY_ID:
      return {
        ...state,
        get_menus_by_id: action.payload,
        loading: false,
      };

    case ADD_TO_CART:
      return {
        ...state,
        add_to_cart: action.payload,
        loading: false,
      };

    case DELETE_CART:
      return {
        ...state,
        delete_cart: action.payload,
        loading: false,
      };

    case OUTLATES:
      return {
        ...state,
        outlates: action.payload,
        loading: false,
      };

    case ORDER:
      return {
        ...state,
        order: action.payload,
        loading: false,
      };

    case ORDERS:
      return {
        ...state,
        orders: action.payload,
        loading: false,
      };

    case ORDER_HISTORY:
      return {
        ...state,
        order_history: action.payload,
        loading: false,
      };

    case RE_ORDERS:
      return {
        ...state,
        reorders: action.payload,
        loading: false,
      };

    case REGISTER:
      return {
        ...state,
        signup: action.payload,
        loading: false,
      };
    case GET_ERRORS:
      return {
        ...state,
        errors: action.payload,
        loading: false,
      };

    case SET_REGISTERED_USER:
      return {
        ...state,
        payload: action.payload,
        loading: false,
      };

    case GET_CUSTOMER_PROFILE:
      return {
        ...state,
        payload: action.payload,
        loading: false,
      };

    case UPDATE_CUSTOMER_PROFILE:
      return {
        ...state,
        payload: action.payload,
        loading: false,
      };

    case SET_CURRENT_USER:
      return {
        ...state,
        payload: action.payload,
        loading: false,
      };
    case SET_LOGIN_ERROR:
      return {
        ...state,
        loading: false,
      };
    case TRACK_ORDER:
      return {
        ...state,
        track_order: action.payload,
        loading: false
      }
    case PLACE_ORDER_PRODUCT:
      return {
        ...state,
        place_order: action.payload,
        loading: false
      }
    case SET_STRIPE_LALAMOVE_KEY:
      return {
        ...state,
        stripeLalaMoveKeys: action.payload
      }
    case CHECK_OUT_PRODUCT:
      return {
        ...state,
        getCheckOutProduct: action.payload
      }
    case GET_CURRENT_OUTLET:
      return {
        ...state,
        getCurrentOutlet: action.payload
      }
    case SET_TOTAL_ORDERS:
      return {
        ...state,
        total_orders: action.payload,
        loader: false
      };
    case TOTAL_ORDERS_LOADER_START:
      return {
        ...state,
        loader: true
      };
    case PRODUCT_COMBO:
      return {
        ...state,
        combo_products: action.payload,
        loading: false,
        errors: null,
    };
    default:
      return state;
  }
  
};
